import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import DecisionMaker from './pages/DecisionMaker';
import MarketAnalysis from './pages/MarketAnalysis';
import BusinessInsight from './pages/BusinessInsight';

function App() {
  return (
    <Router>
  <div className="min-h-screen bg-gradient-to-br from-black via-gray-900 to-black">
        <Navbar />
        <main className="container mx-auto">
          <Routes>
            <Route path="/" element={<BusinessInsight />} />
            <Route path="/business-insight" element={<BusinessInsight />} />
            <Route path="/market-analysis" element={<MarketAnalysis />} />
            <Route path="/decision-maker" element={<DecisionMaker />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;